import styled from "styled-components";
import { media } from "../../../../utils";

export const ContentBody = styled.div`
  display: flex;
`;

export const ImgMobile = styled.img`
  width: 100px;
  margin-right: 20px;
  ${media.md()} {
    display: none;
  }
`;
